<fin-booking-plain-header-area
  [title]="'MMB.reviewPage.shoppingCartTitle' | finLocalization"
></fin-booking-plain-header-area>
<ng-container *ngIf="(showLoader$ | async) === true">
  <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" [paragraph]="'MMB.cart.loading'"></fcom-loader>
</ng-container>
<ng-container *ngIf="(showLoader$ | async) === false">
  <ng-container *ngIf="(cartIsEmpty$ | async) === true; else default">
    <fcom-notification>{{ 'MMB.cart.cartIsEmpty' | finLocalization }}</fcom-notification>
  </ng-container>
  <ng-template #default>
    <fin-included-products
      class="block mr-xsmall-t"
      [booking]="order$ | async"
      [useCabinClass]="false"
      [titleTranslationKey]="'purchaseSummaryItemNames.ancillaries'"
      [showAdditionalTitle]="true"
      [expandOpen]="true"
      [servicesToShow]="services$ | async"
      [isShoppingCart]="true"
      [groupServicesByBound]="true"
      [removeInProgress$]="serviceRemoveProgressInfo$"
      [showPendingServicesInTitles]="true"
      (upsellClicked)="modifyClicked($event)"
      (removeProduct)="removeProduct($event)"
    ></fin-included-products>
    <fin-section-review
      class="mr-xsmall-t purchase-review-total-prices"
      [title]="'price.grandTotal' | finLocalization"
      [endTitle]="(order$ | async)?.prices?.unpaid?.total?.total?.totalAmount | finPrice: { useSymbol: false }"
      [noContent]="true"
      [noButton]="true"
    >
    </fin-section-review>
    <fin-form-fields *ngIf="!disableTermsAndConditionCheckbox">
      <fin-input-checkbox
        class="block pr-xsmall-t pr-large-b"
        [containerClass]="'flex'"
        [labelClass]="'font-body-1 inline-block pr-xxsmall-l'"
        [group]="reviewForm"
        [modelName]="'confirm'"
        [name]="'confirm'"
        [hideError]="true"
        [required]="true"
        [innerHtml]="(termAndCondition$ | async)?.teaserText"
        (checkboxChange)="acceptTerms($event)"
      ></fin-input-checkbox>
    </fin-form-fields>
  </ng-template>
</ng-container>
<fcom-cta-button
  data-testid="manage-booking-review-route-cta-button"
  *finLet="cartIsEmpty$ | async as cartIsEmpty"
  [title]="(!cartIsEmpty ? 'purchase.review.proceed' : 'MMB.modifyYourTrip.labels.addExtras') | finLocalization"
  [disabled]="(formValid$ | async) === false"
  [visible]="(showLoader$ | async) === false"
  [position]="ButtonPosition.GRID_FULL"
  [loading]="(serviceRemoveProgressInfo$ | async).removeInProgress === true"
  (buttonClicked)="payOrAdd(cartIsEmpty)"
>
  <span *ngIf="cartIsEmpty">
    {{ 'MMB.cart.noItemsInCart' | finLocalization }}
  </span>
  <ng-container *ngIf="!cartIsEmpty">
    <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
    <span class="font-body-1">{{
      (order$ | async)?.prices?.unpaid?.total?.total?.totalAmount | finPrice: { useSymbol: false }
    }}</span>
  </ng-container>
</fcom-cta-button>
